import Vue from 'vue'


import App from './App.vue'
import VueRouter from 'vue-router'

import LandingContactComponent from './components/contact-component/Landing-Contact-Component.vue'
import LandingPrivacyComponent from './components/privacy-component/Landing-Privacy-Component.vue'
import LandingImprintComponent from './components/imprint-component/Landing-Imprint-Component.vue'
import LandingStartComponent from './components/start-component/Landing-Start-Component.vue'

import './assets/css/text-styles.css'
import './assets/css/widget-styles.css'
import './assets/css/field-styles.css'


import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars} from '@fortawesome/free-solid-svg-icons'
import { faTimes} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

library.add(
	faBars,
	faTimes
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.config.productionTip = false

const routes = [
		{path: '/contact', component: LandingContactComponent},
		{path: '/privacy', component: LandingPrivacyComponent},
		{path: '/imprint', component: LandingImprintComponent},
		{path: '', name: 'home', component: LandingStartComponent},
		{path: '/', name: 'home', component: LandingStartComponent},
		{path: '*', redirect: '/'}
	]



const router = new VueRouter({
		routes: routes
	})

Vue.use(VueRouter);


new Vue({
	data: () => ({
		
	}),
	router,
	
	render: h => h(App),
}).$mount('#app')


